var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',[_c('span',{staticClass:"number",domProps:{"innerHTML":_vm._s(_vm.number)}}),_c('br'),_c('span',{staticClass:"textSize",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }